import { useId } from 'react';
import { Tooltip } from 'react-tooltip';

interface IDisabled {
  disabled: boolean;
  reason: string;
}

interface IProps {
  onClick: () => void;
  text: string;
  disabled?: IDisabled[];
}

export const Button = ({ onClick, text, disabled }: IProps) => {
  const isDisabled = disabled && disabled.some((d) => d.disabled);
  const tooltipId = `button-tooltip-${useId()}`;

  const tooltipContent = disabled
    ?.filter((d) => d.disabled)
    .map((d) => d.reason)
    .join('\n');

  return (
    <>
      <button
        type="button"
        disabled={isDisabled}
        className={`bg-blue-500  text-white text-sm font-thin py-2 p-3 rounded h-10 ${
          isDisabled ? 'disabled:opacity-50' : 'hover:bg-blue-700'
        }`}
        onClick={onClick}
        data-tooltip-id={isDisabled ? tooltipId : undefined}
        data-tooltip-content={tooltipContent}
      >
        {text}
      </button>
      {isDisabled && (
        <Tooltip
          id={tooltipId}
          place="top"
          style={{ whiteSpace: 'pre-line' }}
        />
      )}
    </>
  );
};
